import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslocoDirective } from '@jsverse/transloco';
import { FormSelectComponent } from '@modules/forms/components/form-select/form-select.component';
import { PatientContactInputComponent } from '@modules/patient/patient-contact-input/patient-contact-input.component';
import { CreatorType } from '@pixacare/domain';
import { TuiCheckbox, TuiError, TuiInput, TuiLabel } from '@taiga-ui/core';
import { TuiInputNumber, TuiTextarea } from '@taiga-ui/kit';
import { LocaleFlagPipe } from '../../../locale/pipes/locale-flag.pipe';
import { TelemonitoringLocalePickerComponent } from '../telemonitoring-locale-picker/telemonitoring-locale-picker.component';
import { TelemonitoringRequestForm } from '../telemonitoring-request/telemonitoring-request-form';

@Component({
  selector: 'pxc-telemonitoring-request-details',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TuiInput,
    TuiInputNumber,
    TuiTextarea,
    TuiLabel,
    TuiError,
    TuiCheckbox,
    PatientContactInputComponent,
    FormSelectComponent,
    TranslocoDirective,
    TelemonitoringLocalePickerComponent,
    LocaleFlagPipe,
  ],
  templateUrl: './telemonitoring-request-details.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TelemonitoringRequestDetailsComponent {
  @Input() defaultName: string | null = null;

  @Input() form: FormGroup<TelemonitoringRequestForm>;

  CreatorType = CreatorType;

  get creatorType(): CreatorType {
    return this.form.get('creatorType').value;
  }

  get patientId(): number | null {
    return this.form.get('patientId').value;
  }

  get clientCode(): string {
    return this.form.get('clientCode').value;
  }

  get localeCode(): string {
    return this.form.get('localeCode').value;
  }

  get isReminderDaysIntervalReadOnly(): boolean {
    return !this.form.get('enableAutomaticReminderForInactivePatient').value;
  }
}
